import { render, staticRenderFns } from "./Cpf.vue?vue&type=template&id=12fb18e5"
import script from "./Cpf.vue?vue&type=script&lang=js"
export * from "./Cpf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports